import { render, staticRenderFns } from "./service-navigation-row.vue?vue&type=template&id=46304c74&"
import script from "./service-navigation-row.vue?vue&type=script&lang=js&"
export * from "./service-navigation-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports